import { BaseServices, HttpMethod } from '@services/base'

interface DocAnexoType {
  type: string
  files: Files[]
}

export interface Files {
  file: string
  extension: string
}

export default async (data: DocAnexoType, cpf: string) => {
  const pathname = process.env.REACT_APP_ENVIAR_ANEXO_APP
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {
    socialDocument: cpf,
  }

  const response = await BaseServices.request({
    headers,
    pathname,
    method,
    host,
    data,
  })
  return response
}
